import { set, sum } from "lodash";
import React, { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import { useForm } from "react-hook-form";
import { Bar } from "react-chartjs-2";
//import Input from "components/shared/Inputs/Inputs";
import SelectList from "components/shared/select/select";
import MetaTags from "react-meta-tags";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Swal from "sweetalert2";
import api from "../../services/api";
import "../../assets/icons/svg/_svg_icons.scss";

const ConsumoEmpresaDetalhe = () => {
  const [dados, setDados] = useState([]);
  const [apiDados, setApiDados] = useState([]);
  const [logs, setLogs] = useState([]);
  const [num_colunas, setNumColunas] = useState(1);
  const [searching, setSearching] = useState(false);

  const [typeEmpresa, setTypeEmpresa] = useState({
    'Comercial': true,
    'Industrial': true,
    'Residencial': true,
    'Publico': true
  });
  const typeEnum = {
    'Residencial': 'C',
    'Comercial': 'L',
    'Industrial': 'I',
    'Publico': 'P'
  };


  const pegarDados = () => {

    api.post(`/monitoring/`).then((response) => {
      setApiDados(response.data);
      Swal.close();
    });
  }

  const filtrar = () => {
    const tiposSelecionados = Object.entries(typeEmpresa)
      .filter(([_, ativo]) => ativo)
      .map(([tipo]) => typeEnum[tipo]);

    const filteredData = apiDados.filter(dado =>
      tiposSelecionados.includes(dado.TP_EMPREENDIMENTO)
    );
    console.log(filteredData);
    setDados(filteredData);
    atualizaLogs(filteredData);

  }


  const atualizaLogs = (content) => {
    let temp_logs = [];
    if (!content || content.length === 0) {
      setLogs([]);
    }
    content.forEach(dado => {

      if (dado.ALARMES && dado.ALARMES.indexOf('Corte') > -1) {
        temp_logs.push([
          {
            'NM_CONDOMINIO': dado.NM_CONDOMINIO,
            'NR_HIDROMETRO': dado.NR_HIDROMETRO,
            "DT_LEITURA": new Date(dado.DT_LEITURA).toLocaleString('pt-BR'),
            "ERRO": 'corte'
          }
        ]);
      }

      if (dado.ALARMES && dado.ALARMES.indexOf('Vazamento') > -1) {
        temp_logs.push([
          {
            'NM_CONDOMINIO': dado.NM_CONDOMINIO,
            'NR_HIDROMETRO': dado.NR_HIDROMETRO,
            "DT_LEITURA": new Date(dado.DT_LEITURA).toLocaleString('pt-BR'),
            "ERRO": 'vazamento'
          }
        ]);
      }

      if (dado.ALARMES && dado.ALARMES.indexOf('Ataque') > -1) {
        temp_logs.push([
          {
            'NM_CONDOMINIO': dado.NM_CONDOMINIO,
            'NR_HIDROMETRO': dado.NR_HIDROMETRO,
            "DT_LEITURA": new Date(dado.DT_LEITURA).toLocaleString('pt-BR'),
            "ERRO": 'magnetico'
          }
        ]);
      }

      if (parseInt(dado.ULTIMA_LEITURA) < parseInt(dado.PENULTIMA_LEITURA)) {
        temp_logs.push([
          {
            'NM_CONDOMINIO': dado.NM_CONDOMINIO,
            'NR_HIDROMETRO': dado.NR_HIDROMETRO,
            "DT_LEITURA": new Date(dado.DT_LEITURA).toLocaleString('pt-BR'),
            "ERRO": 'reverso'
          }
        ]);
      }

      if (dado.TRAVADO > 0) {
        temp_logs.push([
          {
            'NM_CONDOMINIO': dado.NM_CONDOMINIO,
            'NR_HIDROMETRO': dado.NR_HIDROMETRO,
            "DT_LEITURA": new Date(dado.DT_LEITURA).toLocaleString('pt-BR'),
            "ERRO": 'travado'
          }
        ]);
      }

      if (dado.SEM_CONSUMO > 0) {
        temp_logs.push([
          {
            'NM_CONDOMINIO': dado.NM_CONDOMINIO,
            'NR_HIDROMETRO': dado.NR_HIDROMETRO,
            "DT_LEITURA": new Date(dado.DT_LEITURA).toLocaleString('pt-BR'),
            "ERRO": 'pulso'
          }
        ]);
      }

      if (parseInt(dado.DS_BATERIA.replace('%', '')) < 49) {
        temp_logs.push([
          {
            'NM_CONDOMINIO': dado.NM_CONDOMINIO,
            'NR_HIDROMETRO': dado.NR_HIDROMETRO,
            "DT_LEITURA": new Date(dado.DT_LEITURA).toLocaleString('pt-BR'),
            "ERRO": 'bateria'
          }
        ]);
      }

      temp_logs.sort((a, b) => {
        const dataA = new Date(a[0].DT_LEITURA.split('/').reverse().join('-'));
        const dataB = new Date(b[0].DT_LEITURA.split('/').reverse().join('-'));
        return dataB - dataA;
      });
      setLogs(temp_logs);
      setNumColunas(Math.ceil(temp_logs.length / 3));
    });
  }

  useEffect(() => {
Swal.fire({
  html: `
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <span style="font-size:30px">Pesquisando...</span>
      <button id="closeSwal" 
        style="
          border: none;
          background: transparent;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
        ">
        ✖
      </button>
    </div>
  `,
  allowOutsideClick: false,
  showConfirmButton: false,
  didOpen: () => {
    Swal.showLoading();

    // evento para o botão X
    document.getElementById("closeSwal").addEventListener("click", () => {
      Swal.close();
    });
  }
});
    pegarDados();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      pegarDados();
    }, 90000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (apiDados && apiDados.length > 0) {
      filtrar();
    }
  }, [apiDados, typeEmpresa]);



  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Consumo Empresas</title>
        </MetaTags>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div id='empresas' className="col-md-9" style={{
            display: "flex",
            flexDirection: "column",
            height: "100%"
          }}>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
              <details style={{
                position: 'absolute',
                left: 0,
                top: 0,
                zIndex: 1000,
                backgroundColor: 'rgba(255,255,255,0.95)',
                margin: 0,
                padding: '10px 20px',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                border: '1px solid #ccc',
                cursor: 'pointer',
                minWidth: '180px'
              }}>


                <summary style={{ fontWeight: 'bold' }}>Tipo de Empresa</summary>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '10px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox" checked={typeEmpresa.Residencial} onChange={() => { setTypeEmpresa(prev => ({ ...prev, Residencial: !prev.Residencial })); }} /> Residencial
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox" checked={typeEmpresa.Comercial} onChange={() => { setTypeEmpresa(prev => ({ ...prev, Comercial: !prev.Comercial })); }} /> Comercio
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox" checked={typeEmpresa.Industrial} onChange={() => { setTypeEmpresa(prev => ({ ...prev, Industrial: !prev.Industrial })); }} /> Industrial
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input type="checkbox" checked={typeEmpresa.Publico} onChange={() => { setTypeEmpresa(prev => ({ ...prev, Publico: !prev.Publico })); }} /> Público
                  </label>
                </div>
              </details>
              <h1 style={{ color: "#0057AA", marginBottom: "30px", fontWeight: "600", textAlign: "center" }}>Consumo Empresas</h1>
            </div>
            <div
              ref={(el) => {
                if (el) {
                  let atualScrol = 0;
                  let somaInternal = true;

                  // Calcular largura real do conteúdo
                  const cardWidth = 300; // largura fixa de cada card
                  const totalWidth = cardWidth * Math.ceil(dados.length / 3); // total de colunas considerando 3 cards por coluna

                  if (num_colunas > 9 && !el.interval) {
                    el.interval = setInterval(() => {
                      atualScrol = somaInternal ? atualScrol + 5 : atualScrol - 5;

                      // Ajustar limites do scroll baseado na largura real
                      if (atualScrol >= totalWidth - el.clientWidth) {
                        somaInternal = false;
                        atualScrol = totalWidth - el.clientWidth;
                      }
                      if (atualScrol <= 0) {
                        somaInternal = true;
                        atualScrol = 0;
                      }

                      el.scrollTo({
                        left: atualScrol,
                        behavior: 'smooth'
                      });
                    }, 150);
                  }
                }
              }}
              style={{
                display: "grid",
                gridTemplateColumns: `repeat(${num_colunas}, 300px)`, // Definir largura fixa das colunas
                gridTemplateRows: "repeat(3, auto)",
                gridAutoFlow: "column",
                gap: "10px",
                overflowX: "hidden",
                scrollBehavior: "smooth",
                WebkitOverflowScrolling: "touch",
                msOverflowStyle: "-ms-autohiding-scrollbar",
                padding: "10px 0"
              }}
            >
              {dados.map((dado, index) => (
                <div key={index} style={{
                  border: "1px solid #0057AA",
                  borderRadius: "10px",
                  padding: "15px",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 8px rgba(0,87,170,0.1)",
                  transition: "transform 0.2s ease-in-out",
                  cursor: "pointer",
                  width: `${(100 / num_colunas) * num_colunas}%`,
                  minWidth: num_colunas > 9 ? "300px" : "auto"
                }}>
                  <span style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    fontSize: "14px",
                    lineHeight: "1.3"
                  }}>
                    <div style={{ fontWeight: "600", color: "#0057AA", fontSize: "16px", marginBottom: "3px" }}>
                      {dado.NM_CONDOMINIO}
                    </div>
                    <div>Leitura Atual: <strong>{dado.ULTIMA_LEITURA}</strong></div>
                    <div>Data: <strong>{new Date(dado.DT_LEITURA).toLocaleDateString()}</strong></div>
                    <div>Hidrometro: <strong>{dado.NR_HIDROMETRO}</strong></div>
                    <div>IDA: <strong>{dado.CD_IDA}</strong></div>
                    <div>
                      Erros:
                      {dado.ALARMES && dado.ALARMES.indexOf('Corte') > -1 ? <> <i className="svg-corte" style={{ color: "#ff4444" }}></i></> : <></>}
                      {dado.ALARMES && dado.ALARMES.indexOf('Vazamento') > -1 ? <> <i className="svg-vazamento" style={{ color: "#ff4444" }}></i></> : <></>}
                      {dado.ALARMES && dado.ALARMES.indexOf('Ataque') > -1 ? <> <i className="svg-magnetico" style={{ color: "#ff4444" }}></i></> : <></>}
                      {parseInt(dado.ULTIMA_LEITURA) < parseInt(dado.PENULTIMA_LEITURA) ? <> <i className="svg-reverso" style={{ color: "#ff4444" }}></i></> : <></>}
                      {dado.TRAVADO > 0 ? <> <i className="svg-travado" style={{ color: "#ff4444" }}></i></> : <></>}
                      {dado.SEM_CONSUMO > 0 ? <> <i className="svg-pulso" style={{ color: "#ff4444" }}></i></> : <></>}
                      {parseInt(dado.DS_BATERIA.replace('%', '')) < 49 ? <> <i className="svg-bateria" style={{ color: "#ff4444" }}></i></> : <></>}
                    </div>
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div id='logs' className="col-md-3" style={{
            borderLeft: "2px solid #0057AA",
            paddingLeft: "20px",
            minHeight: "100%",
            display: "flex",
            flexDirection: "column"
          }}>
            <h2 style={{ color: "#0057AA", marginBottom: "30px", fontWeight: "600" }}>Log empresas</h2>
            <div style={{
              overflowY: "auto",
              maxHeight: "calc(100vh - 150px)",
              paddingRight: "10px",
              display: "flex",
              flexDirection: "column-reverse"
            }}>
              {logs.map((log, index) => (
                <div key={index} style={{
                  border: "1px solid #0057AA",
                  borderRadius: "10px",
                  padding: "15px",
                  marginBottom: "20px",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 8px rgba(0,87,170,0.1)",
                  transition: "transform 0.2s ease-in-out",
                  cursor: "pointer"
                }}>
                  <span style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    fontSize: "14px",
                    lineHeight: "1.3"
                  }}>
                    <div style={{ fontWeight: "600", color: "#0057AA", fontSize: "16px", marginBottom: "3px" }}>
                      {log.NM_CONDOMINIO}
                    </div>
                    <div>Nome do condomínio: <strong>{log[0].NM_CONDOMINIO}</strong></div>
                    <div>Hidrometro: <strong>{log[0].NR_HIDROMETRO}</strong></div>
                    <div>Data do registro: <strong>{log[0].DT_LEITURA}</strong> </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>Erro: <i className={`svg-${log[0].ERRO}`} style={{ color: "#ff4444" }}></i></div>
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            width: "100%",
            padding: "5px",
            backgroundColor: "rgba(248, 249, 250, 0.6)",
            borderTop: "1px solid #0057AA",
            backdropFilter: "blur(5px)",
            zIndex: 9999
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 20px" }}>
              <div><i className="svg-corte" style={{ color: "#ff4444" }}></i> Corte de Cabo</div>
              <div><i className="svg-vazamento" style={{ color: "#ff4444" }}></i> Vazamento Detectado</div>
              <div><i className="svg-magnetico" style={{ color: "#ff4444" }}></i> Ataque Magnético</div>
              <div><i className="svg-reverso" style={{ color: "#ff4444" }}></i>Consumo Reverso</div>
              <div><i className="svg-travado" style={{ color: "#ff4444" }}></i> Medidor Travado</div>
              <div><i className="svg-pulso" style={{ color: "#ff4444" }}></i> Medidor Sem Consumo</div>
              <div><i className="svg-bateria" style={{ color: "#ff4444" }}></i> Bateria Baixa</div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ConsumoEmpresaDetalhe;
